import 'babel-polyfill'
import smoothscroll from 'smoothscroll-polyfill';

// kick off the polyfill!
smoothscroll.polyfill();


// WEBPACK FOOTER //
// ./src/plugins/polyfills.js